// Pure JS implementation of faker functions used in the codebase

const firstNames = [
  'John',
  'Jane',
  'Michael',
  'Sarah',
  'David',
  'Emma',
  'James',
  'Emily',
  'William',
  'Olivia',
  'Robert',
  'Sophia',
  'Joseph',
  'Isabella',
  'Thomas',
  'Mia',
]

const lastNames = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Garcia',
  'Miller',
  'Davis',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Wilson',
  'Anderson',
]

const loremWords = [
  'lorem',
  'ipsum',
  'dolor',
  'sit',
  'amet',
  'consectetur',
  'adipiscing',
  'elit',
  'sed',
  'do',
  'eiusmod',
  'tempor',
  'incididunt',
  'ut',
  'labore',
  'et',
  'dolore',
  'magna',
  'aliqua',
  'enim',
  'ad',
  'minim',
  'veniam',
  'quis',
  'nostrud',
  'exercitation',
]

const getRandomElement = (array) =>
  array[Math.floor(Math.random() * array.length)]

const generateSentence = (minWords = 5, maxWords = 15) => {
  const length =
    Math.floor(Math.random() * (maxWords - minWords + 1)) + minWords
  const words = Array.from({ length }, () => getRandomElement(loremWords))
  return words.join(' ') + '.'
}

export const faker = {
  name: {
    findName: () =>
      `${getRandomElement(firstNames)} ${getRandomElement(lastNames)}`,
  },
  lorem: {
    paragraph: (sentenceCount = 3) => {
      const count = Math.max(1, Math.min(10, sentenceCount))
      return Array.from({ length: count }, () => generateSentence()).join(' ')
    },
  },
}
